import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Zap, BrainCircuit, ShieldCheck } from 'lucide-react';
export function UniqueMechanism() {
  return <AnimatedSection className="bg-charcoal text-white relative overflow-hidden" data-id="element-220">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-221" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-mint/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-222" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-223">
        <div className="text-center space-y-6 mb-12" data-id="element-224">
          <div className="inline-flex items-center gap-2 bg-gold/20 text-gold-light px-4 py-2 rounded-full font-semibold text-sm tracking-wide uppercase border border-gold/30" data-id="element-225">
            <Zap className="w-4 h-4" data-id="element-226" />
            La Solución Biológica
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-cream" data-id="element-227">
            Presentamos el Método de Reinicio en 60 Segundos
          </h2>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 md:p-12 rounded-3xl" data-id="element-228">
          <p className="text-xl md:text-2xl leading-relaxed text-cream-dark font-light text-center mb-10" data-id="element-229">
            A diferencia de las terapias largas, este sistema utiliza anclajes
            sensoriales bilingües diseñados para{' '}
            <strong className="text-gold-light font-bold" data-id="element-230">
              "engañar" a tu amígdala
            </strong>{' '}
            y devolverle el control a tu cerebro lógico en menos de un minuto.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-lg" data-id="element-231">
            <div className="flex items-center gap-3 bg-white/10 px-6 py-4 rounded-2xl w-full sm:w-auto justify-center" data-id="element-232">
              <BrainCircuit className="w-6 h-6 text-mint" data-id="element-233" />
              <span data-id="element-234">No es fuerza de voluntad</span>
            </div>
            <div className="hidden sm:block text-gold-light font-bold text-2xl" data-id="element-235">
              →
            </div>
            <div className="flex items-center gap-3 bg-gold/20 border border-gold/30 px-6 py-4 rounded-2xl w-full sm:w-auto justify-center" data-id="element-236">
              <ShieldCheck className="w-6 h-6 text-gold-light" data-id="element-237" />
              <span className="font-semibold text-gold-light" data-id="element-238">
                Es un interruptor físico para un problema biológico
              </span>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}